import AnyOrangeJuice from "../../images/questionIcons/1-AnyOrangeJuice.jpg";
import MinuteMaid from "../../images/questionIcons/1-MinuteMaid.jpg";
import GasShortTerm from "../../images/questionIcons/2-Gas-short-term.jpg";
import GasLongTerm from "../../images/questionIcons/2-Gas-long-term.jpg";
import CoffeeFinals from "../../images/questionIcons/3-Coffee-finals.jpg";
import CoffeeSummerVacation from "../../images/questionIcons/3-Coffee-summervacation.jpg";
import DiamondLeft from "../../images/questionIcons/4-Diamond-left.jpg";
import DiamondRight from "../../images/questionIcons/4-Diamond-right.jpg";
import TVBoth from "../../images/questionIcons/5-TV(both).jpg";
import AllBoroughs from "../../images/questionIcons/6-all-boroughs.jpg";
import Brooklyn from "../../images/questionIcons/6-brooklyn.jpg";
import Brocolli from "../../images/questionIcons/7-Brocolli.jpg";
import Vegetables from "../../images/questionIcons/7-Vegetables.jpg";
import SanitiserBoth from "../../images/questionIcons/8-sanitiser(both).jpg";
import ChargerEmpty1Percent from "../../images/questionIcons/9-Charger-Empty1percent.jpg";
import ChargerFull92Percent from "../../images/questionIcons/9-Charger-Full92percent.jpg";
import TShirt from "../../images/questionIcons/10-T-shirt.jpg";
import Proof from "../../images/questionIcons/10-Proof.jpg";

// #TODO
// #ADD SPACE UNDER TEXT OF QUEST 4
// #REMOVE . AFTER DIMOND 
// #BIGGER FONT FOR INTO moduleSass
// #CHECK QESURION AFTER 2ND INTRO MODAL


// import Q1 from "../../images/G1.svg";
// import Q2 from "../../images/G2.svg";
// import Q3 from "../../images/G3.svg";
// import Q4 from "../../images/G4.svg";
// import Q5 from "../../images/G5.svg";
// import Q6 from "../../images/G6.svg";
// import Q7 from "../../images/G7.svg";
// import Q8 from "../../images/G8.svg";
// import Q9 from "../../images/G9.svg";
// import Q10 from "../../images/G10.svg";

const questionSet = [
  {
    title: "Which of the two goods has MORE ELASTIC demand?",
    // subTitle: "AIR JORDANS",
    answer: 1, //1 mean old image selection is correct
    detailText:
      "There are more substitutes for a particular brand and pulp level of orange juice, such as Minute Maid (no pulp), than for orange juice as a beverage category.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Nike.com as of 3/22 (new price)',
    old: {
      // price: "56.95",
      // year: 1985,
      name: "Minute Maid Orange Juice (no pulp)",
      // cpi: 108,
      image: MinuteMaid,
    },
    new: {
      // price: "140.00",
      // year: 2022,
      name: "Orange Juice (any brand)",
      // cpi: 296,
      image: AnyOrangeJuice,
    },
    // equation: Q1,
    // inflation: {
    //   // price: "156.09",
    //   // year: 2022,
    //   name: "Insulin",
    // },
  },

  {
    title: "Which of the two goods has MORE ELASTIC demand?",
    // subTitle: "BIG MAC",
    answer: 2,
    detailText:
      "Demand is more elastic in the long run because consumers have more time to adjust their behavior. In the short run, if gas prices double, people might reduce discretionary trips or carpool occasionally, but their ability to cut back is limited—making demand relatively inelastic. However, in the long run, consumers can make bigger changes, like switching to electric cars, using public transportation, or moving closer to work, leading to more elastic demand as they significantly reduce or eliminate gas consumption.",
    sourcesText:
      "<span style='color: #898989;'>SOURCES:</span> Period advertisement (old price), McDonald's app in Los Angeles (new price)",
    old: {
      // price: "0.49",
      // year: 1968,
      name: "Gas in the Short Run",
      // cpi: 35,
      image: GasShortTerm,
    },
    new: {
      // price: "5.29",
      // year: 2022,
      name: "Gas in the Long Run",
      // cpi: 296,
      image: GasLongTerm,
    },
    // equation: Q2,
    // inflation: {
    //   // price: "4.14",
    //   // year: 2022,
    //   name: "",
    // },
  },

  {
    title: "Which of the two goods has MORE ELASTIC demand?",
    // subTitle: "LOS ANGELES HOUSE",
    answer: 2, //1 mean old image selection is correct
    detailText:
      "During finals week, coffee feels like a necessity—students rely on it to stay awake and focused, making their demand more inelastic. Even if prices rise, they'll likely continue buying it. In contrast, during summer break, coffee is more of a routine or leisure good rather than an urgent need. Students can cut back, switch to alternatives, or go without, making their demand more elastic.",
    sourcesText: '<span style="color: #898989;">SOURCE:</span> Redfin.com',
    old: {
      // price: "43,500",
      // year: 1976,
      name: "Coffee During Finals Week",
      // cpi: 57,
      image: CoffeeFinals,
    },
    new: {
      // price: "911,963",
      // year: 2022,
      name: "Coffee During Summer Vacation",
      // cpi: 296,
      image: CoffeeSummerVacation,
    },
    // equation: Q3,
    // inflation: {
    //   // price: "225,895",
    //   // year: 2022,
    //   name: "",
    // },
  },

  {
    title: "Which of the two goods has MORE ELASTIC demand?",
    // subTitle: '27" TELEVISION',
    answer: 2,
    detailText:
      "After lab grown diamonds become more available, customers have increased access to a close substitute for real diamonds, so they will become more sensitive to price changes. Demand for real diamonds will be more elastic after the introduction of lab grown diamonds.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> as of 3/22 (new price)',
    old: {
      // price: "279.95",
      // year: 1953,
      name: "Demand for Natural Diamonds (BEFORE the widespread availabilty of lab grown diamonds)",
      // cpi: 27,
      image: DiamondLeft,
    },
    new: {
      // price: "449.94",
      // year: 2022,
      name: "Demand for Natural Diamonds (AFTER the widespread availability of lab grown diamonds)",
      // cpi: 296,
      image: DiamondRight,
    },
    // equation: Q4,
    // inflation: {
    //   // price: "3,069",
    //   // year: 2022,
    //   name: "",
    // },
  },

  {
    title: "Which of the two goods has MORE ELASTIC demand?",
    // subTitle: "FORD SEDAN",
    answer: 2,
    detailText:
      "For a struggling student, a new TV represents a significant expense, making them highly price-sensitive—they'll compare prices, wait for deals, or even forgo the purchase if it's too expensive. This makes their demand more elastic. In contrast, for Jeff Bezos, the cost of a TV is negligible relative to his wealth, so price changes have little to no effect on his decision. This makes his demand highly inelastic—he’ll buy the TV regardless of the price.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.kbb.com/">KBB.com</a> (new price for 2020 Ford Fusion)',
    old: {
      // price: "850",
      // year: 1909,
      name: "A New TV for Jeff Bezos",
      // cpi: 9,
      image: TVBoth,
    },
    new: {
      // price: "23,170",
      // year: 2020,
      name: "A New TV for a Struggling Student",
      // cpi: 259,
      image: TVBoth,
    },
    // equation: Q5,
    // inflation: {
    //   // price: "24,461",
    //   // year: 2020,
    //   name: "",
    // },
  },

  {
    title: "Which of these goods has MORE INELASTIC demand?",
    // subTitle: "LEGO X-WING FIGHTER",
    answer: 1,
    detailText:
      "Demand for rental apartments in NYC will be more inelastic than for apartments in one specific borough, since renters can subsitute rental apartments in nearby boroughs and still make it to the office.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> (new price)',
    old: {
      // price: "30",
      // year: 1999,
      name: "Rental Apartments in New York City (all 5 boroughs)",
      // cpi: 167,
      image: AllBoroughs,
    },
    new: {
      // price: "50",
      // year: 2022,
      name: "Rental Apartments in Brooklyn",
      // cpi: 296,
      image: Brooklyn,
    },
    // equation: Q6,
    // inflation: {
    //   // price: "53.17",
    //   // year: 2022,
    //   name: "",
    // },
  },

  {
    title: "Which of these goods has MORE INELASTIC demand?",
    // subTitle: "TOOTH FAIRY (average tooth price)",
    answer: 2,
    detailText: "Demand for vegetables as a broad category is more inelastic than demand for a specific vegetable, like broccoli. That’s because it’s much easier for consumers to substitute one vegetable (say, broccoli) with another (like cauliflower or Brussels sprouts) than it is to replace all vegetables with other types of food.",
    sourcesText:
      '<span style="color: #898989;">SOURCE:</span> <a  style="color: #898989" target="_black" href="www.deltadental.com/us/en/tooth-fairy/the-original-poll.html">Delta Dental Poll</a>',
    old: {
      // price: "1.60",
      // year: 2001,
      name: "Demand for Broccoli",
      // cpi: 177,
      image: Brocolli,
    },
    new: {
      // price: "5.36",
      // year: 2022,
      name: "Demand for Vegetables",
      // cpi: 296,
      image: Vegetables,
    },
    // equation: Q7,
    // inflation: {
    //   // price: "2.68",
    //   // year: 2022,
    //   name: "",
    // },
  },
  {
    title: "Which of these goods has MORE INELASTIC demand?",
    // subTitle: "PAUL RUDD ACTING FEE",
    answer: 2,
    detailText:
      "During the COVID pandemic, heightened fear of the virus caused demand for hand sanitizer to surge as people sought ways to protect themselves. They became significantly less sensitive to the price than prior to the pandemic.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> "Clueless" salary estimated from leading role salaries at the time. "Antman" salary from <a  style="color: #898989" target="_black" href="https://news.yahoo.com/">Yahoo News</a>.',
    old: {
      // price: "150,000",
      // asteric: "*",
      // year: 1995,
      name: "Demand for Hand Sanitizer in June 2019 (pre-COVID)",
      // yearWithText: "1995 (Clueless)",
      // cpi: 152,
      image: SanitiserBoth,
    },
    new: {
      // price: "300,000",
      // asteric: "*",
      // year: 2015,
      name: "Demand for Hand Sanitizer in June 2020 (during COVID pandemic)",
      // yearWithText: "2015 (AntMan)",
      // cpi: 237,
      image: SanitiserBoth,
    },
    // equation: Q8,
    // inflation: {
    //   // price: "233,282",
    //   // year: 2015,
    //   name: "",
    // },
  },
  ///
  {
    title: "Which of these goods has MORE INELASTIC demand?",
    // subTitle: "UNDERWEAR",
    answer: 1,
    detailText: "When your phone battery is at 1%, a charger becomes a necessity—you need it immediately, making you less price-sensitive and your demand more inelastic. However, when your phone is at 92%, you have the flexibility to wait, shop around, or delay the purchase, making your demand more elastic. The urgency of need plays a major role in determining price sensitivity and demand elasticity.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> (new price)',
    old: {
      // price: "1.00",
      // year: 1949,
      name: "Phone Charger When Your battery Is at 1%",
      // cpi: 24,
      image: ChargerEmpty1Percent,
    },
    new: {
      // price: "4.03",
      // year: 2022,
      name: "Phone Charger When Your battery Is at 92%",
      // cpi: 296,
      image: ChargerFull92Percent,
    },
    // equation: Q9,
    // inflation: {
    //   // price: "12.33",
    //   // year: 2022,
    //   name: "",
    // },
  },
  {
    title: "Which of these goods has MORE INELASTIC demand?",
    // subTitle: "LONG ACTING INSULIN (per unit)",
    answer: 2,
    detailText:
      "Proof that you completed this interactive is a necessity for your grade, meaning you have little choice but to obtain it—making your demand relatively inelastic compared to when it is optional.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> <a  style="color: #898989" target="_black" href="http://americanactionforum.org/insight/insulin-prices-an-update/">Americanactionforum.org</a>',
    old: {
      // price: "0.05",
      // year: 2001,
      name: "Proof you did this interactive practice when it is optional",
      // cpi: 177,
      image: Proof,
    },
    new: {
      // price: "0.25",
      // year: 2020,
      name: "Proof you did this interactive practice needed for class credit",
      // cpi: 259,
      image: Proof,
    },
    // equation: Q10,
    // inflation: {
    //   // price: "0.073",
    //   // year: 2020,
    //   name: "",
    // },
  },
];

export default questionSet;
